import { FeatureGroup, Marker, Polyline, Polyline, Tooltip, useMap } from "react-leaflet";
import { divIcon, DivIcon } from "leaflet";
import { useQueryGtfsResourceById } from "../../Queries";
import { useContext, useEffect, useMemo, useRef } from "react";
import { ToolsContext } from "../../ToolsContext";

export function TripLayer() {
    const tool = useContext(ToolsContext);
    const map = useMap();
    const GTrip = tool.selection;
    const fgRef = useRef(null);
    const {isPending: stopsIsPending, error: stopsError, data: stopsData} = useQueryGtfsResourceById('trips',GTrip.trip_id,'stop_times');
    const {isPending: shapeIsPending, error: shapeError, data: shapeData} = useQueryGtfsResourceById('shapes',GTrip.shape_id);

    const fgHandlers = useMemo(
        () => ({
            add() {
                map.fitBounds(fgRef.current.getBounds());
            }
        }),[map, fgRef.current]
    ); 


    if (shapeIsPending || shapeError || !shapeData || 
        stopsIsPending || stopsError || !stopsData
    ) {
        return <></>
    }    

    const divStopIcon = new DivIcon({className: 'trip-stop-marker'});

    console.log('stopsData',stopsData);
    const TripPolyline = <Polyline key={GTrip.shape_id} positions={shapeData}></Polyline>
    const StopsMarkers = stopsData.map((stopTime,index) => <Marker 
        key={stopTime.stop_sequence}
        position={[stopTime.stop_lat, stopTime.stop_lon]}
        icon={divStopIcon}>
            <Tooltip>
                {index}. [{(stopTime.arrival_time === stopTime.departure_time) ? <>{stopTime.departure_time}</> : <>{stopTime.arrival_time} — {stopTime.departure_time}</>}]&nbsp;
                {stopTime.stop_name}
            </Tooltip>           
    </Marker>);

    return (
        <FeatureGroup ref={fgRef} key={GTrip.trip_id} eventHandlers={fgHandlers}>
            {TripPolyline}
            {StopsMarkers}
        </FeatureGroup>        
    )

}